import { styled } from '@mui/material/styles';
import { AvatarGroup } from 'shared/mui/AvatarGroup/AvatarGroup';
import { DatagridWithStickyActions } from 'shared/react-admin/Datagrids/DatagridWithStickyActions/DatagridWithStickyActions';

export const StyledDatagridWithStickyActions = styled(DatagridWithStickyActions)({
  '& .MuiTableCell-head': {
    padding: '10px 16px',
  },
  '& .MuiTableCell-body': {
    verticalAlign: 'middle',
  },
});

export const StyledAvatarGroup = styled(AvatarGroup)({
  width: 'fit-content',
  '& .MuiAvatarGroup-avatar': {
    height: 24,
    width: 24,
    fontSize: '11px',
    fontWeight: 500,
  },
});
